// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import * as React from "react";

import { getEnv } from "../../utils/env";
import { ApplicationEnvironmentContext } from "./ApplicationEnvironmentContext";

export type ApplicationEnvironmentContextProviderProps = {
	/** Primary content. */
	children?: React.ReactNode;
};

// eslint-disable-next-line max-len
export type ApplicationEnvironmentContextProviderType =
	React.ComponentType<ApplicationEnvironmentContextProviderProps>;

export const ApplicationEnvironmentContextProvider: ApplicationEnvironmentContextProviderType =
	(props: ApplicationEnvironmentContextProviderProps) => {
		const { children } = props;

		const { Provider } = ApplicationEnvironmentContext;

		const [mode, setMode] = React.useState<
			"development" | "testing" | "staging" | "production"
		>(null);

		React.useEffect(() => {
			setMode(getEnv());
		}, []);

		return React.useMemo(
			() => <Provider value={mode}>{children}</Provider>,
			[children, mode],
		);
	};
